import React, { useEffect, useRef } from 'react'
import Slider from 'react-slick'
import history from '../../store/history'

import macCart from '../../assets/Icons/macCartIcon.svg'
import checked from '../../assets/Icons/checkedIcon.svg'
// import magalu from '../../assets/Icons/magaluLogo.svg'
import imac from '../../assets/Images/imacImg.png'
import { DefaultRegularPages } from '../DefaultPages'

import { Accordion, Container, Typography, Button } from '../../components'

import * as S from './styles'
import { pillars, info, benefits } from './pillars'
import useScrollToTop from '../../hooks/useScrollToTop'

const Home = () => {
  const { scrollToTop } = useScrollToTop()
  const certificationRef = useRef(null)
  const benefitsRef = useRef(null)

  useEffect(() => {
    scrollToTop()
  }, [scrollToTop])

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false
  }

  const secondSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dotsClass: ['slick-dots slick-dots2']
  }

  return (
    <DefaultRegularPages landingPageRefs={{ certificationRef, benefitsRef }}>
      <Container>
        <S.FirstSection>
          <S.FirstItems>
            <Typography type="h1" color="#fff" weight="bold">
              O<span style={{ color: '#BE9137' }}> DNA</span> do seu ecommerce
            </Typography>
            <Typography type="h1" color="#fff" weight="bold">
              {' '}
              em forma de certificação
            </Typography>
            <Typography type="h4" color="#fff" spacing="32px 0 0 0">
              A certificação
              <span style={{ color: '#BE9137' }}> DNA ECBR</span> oferece um
              panorama geral de
            </Typography>
            <Typography type="h4" color="#fff">
              todos os aspectos da sua empresa.
            </Typography>
            <Button
              variant="primary"
              text="OBTER CERTIFICAÇÃO"
              width="280px"
              height="60px"
              margin="60px 0 0 0"
              onClick={() => history.push('/signup')}
            />
          </S.FirstItems>
        </S.FirstSection>
        <S.SecondSection ref={certificationRef}>
          <Typography type="h2" color="#000" weight="bold">
            ECBR DNA
          </Typography>
          <Typography
            type="h4"
            color="#7D7987"
            weight="bold"
            spacing="16px 0 0 0"
          >
            A certificação oficial do E-Commerce Brasil que te ajuda a elevar a
            régua do seu e-commerce!
          </Typography>
          <Typography type="h4" color="#7D7987" weight="bold">
            estrutura de ecommerce:
          </Typography>
          <div style={{ maxWidth: '95%', padding: '30px' }}>
            <Slider {...settings}>
              {pillars?.map?.((pillar) => (
                <S.SlideCard key={pillar}>
                  <S.PillarItem width="300px">
                    <img src={macCart} atl="imgCart" />
                    <Typography type="h3" spacing="18px 0 8px 0">
                      {pillar.name}
                    </Typography>
                    <Typography type="text">{pillar.text}</Typography>
                  </S.PillarItem>
                </S.SlideCard>
              ))}
            </Slider>
          </div>
        </S.SecondSection>
        <S.ThirdSection>
          <S.ThirdSectionItem>
            <Typography type="h2" spacing="0 0 60px 20px">
              Conheça um pouco mais sobre a certificação
            </Typography>
            <img src={imac} alt="imac" />
          </S.ThirdSectionItem>
          <S.ThirdSectionItem>
            <Typography type="text" spacing="0 0 40px 20px" color="#7A7786">
              O ECBR DNA é o programa de certificação oficial do E-Commerce
              Brasil que tem como objetivo ajudar os varejistas a analisarem
              suas operações e obter um certificado de excelência com base nos
              critérios avaliados.
            </Typography>
            <Accordion data={info} />
          </S.ThirdSectionItem>
        </S.ThirdSection>
        <S.FourthSection ref={benefitsRef}>
          <Typography type="h2" color="#fff" weight="bold">
            Benefícios da certificação
          </Typography>
          <div style={{ maxWidth: '95%', padding: '30px' }}>
            <Slider {...secondSettings}>
              {benefits?.map?.((item) => (
                <S.SlideCard key={item}>
                  <S.PillarItem>
                    <S.ItemHeader>
                      <img src={checked} atl="check" />
                      <Typography
                        type="h4"
                        spacing="0 0 0 16px"
                        color="#fff"
                        weight="500"
                      >
                        {item.title}
                      </Typography>
                    </S.ItemHeader>
                    <Typography type="text" color="#fff" spacing="16px 0">
                      {item.text}
                    </Typography>
                  </S.PillarItem>
                </S.SlideCard>
              ))}
            </Slider>
          </div>
          <Button
            type="button"
            variant="secondary"
            text="OBTER CERTIFICAÇÃO"
            width="280px"
            height="60px"
            margin="60px 0 0 0"
            onClick={() => history.push('/signup')}
          />
        </S.FourthSection>
        {/* <S.FifthSection>
        <Typography type="h2" weight="bold">
          Empresas certificadas
        </Typography>
        <div style={{ maxWidth: '95%', minWidth: '95%', padding: '30px' }}>
          <S.SliderBorder />
          <Slider {...settings} dotsClass={['slick-dots slick-dots3']}>
            {benefits.map((item) => (
              <S.BrandsCard key={item}>
                <img src={magalu} atl="magalu" />
              </S.BrandsCard>
            ))}
          </Slider>
          <S.SliderBorder bottom />
        </div>
      </S.FifthSection> */}
      </Container>
    </DefaultRegularPages>
  )
}

export default Home
